<template>
  <div v-if="this.inviteData">
    <div ref="detail" class="invite-detail"
      :class="{'scrolled': this.scrolled, 'show-popup': this.showPopup || this.showCheckPopup || this.showPopupNodes , 'show-modal': this.modalTip}"
      v-on:scroll.passive="handleScroll">
      <div v-if="this.inviteData" class="header" :class="{'posiFix': this.scrolled,'operationDele': !this.isOwner && !this.inviteData.isWarehouseManager}">
        <div class="header-inner">
          <div class="row top" :class="{'posiFix': this.scrolled}">
            <h2 class=" col-9 title">{{this.inviteData.priVisitorName}} {{this.inviteData.typeName}} {{this.inviteData.areaName}}
            </h2>
            <div class="col-3">
              <router-link to="/" class="go-back"><i class="iconfont icon-close"></i></router-link>
            </div>
          </div>
          <div class="header-content">
            <div class="dock-number" v-if="this.inviteData.dockNumber">{{$t('DockNumber')}}:&nbsp;&nbsp;{{this.inviteData.dockNumber}}</div>
            <div class="business">{{$t('areaType')}}&nbsp;&nbsp;{{this.inviteData.areaName}}/{{this.inviteData.typeName}}</div>
            <div class="bottler-order" v-if="this.inviteData.bottleOrderNumberList && this.inviteData.bottleOrderNumberList.length && this.inviteData.isCarrierTicket">{{$t('bottler')}}/{{$t('OrderNumber')}}:&nbsp;&nbsp;<span v-for="(item, index) in this.inviteData.bottleOrderNumberList" :key="index">{{item.bottleName}}<span v-if="item.orderNumber">/</span>{{item.orderNumber}} </span>
            </div>
            <div class="apply-status" v-if="this.inviteData.isCarrierTicket">{{$t('ApplyStatus')}}： {{this.inviteData.checkStatusText}}</div>
            <div class="time">{{$t('visitTime')}} {{this.inviteData.startDay}} - {{this.inviteData.endDay}}</div>
            <div class="apply-time" v-if="this.inviteData.isCarrierTicket">{{$t('ExpectedVisitPeriod')}}： {{this.inviteData.schedule}}</div>
            <div class="time">{{$t('VisitorInfo')}} {{this.inviteData.priVisitorName}}/{{this.inviteData.priVisitorPhoneNumber}}{{this.inviteData.priEmail}}</div>
            <div class="training" v-show="this.lessonList !='' ">{{$t('Course')}} {{this.lessonList}}</div>
            <div class="creater">{{$t('creator')}} {{this.inviteData.creatorName}}</div>
            <div class="approver-copier row"  v-show="gmListShow"  v-for='(item, index) in this.inviteData.gmList' :key="index">
              <div v-if="item.gmName">
                {{$t('gMApprover')}}  {{item.gmName}}
              </div>
              <div class="approver">
                <span v-if="item.gmCheckStatus == 0"><i class="iconfont icon-clock"></i>{{$t('sayInformed')}}</span>
                <span v-if="item.gmCheckStatus == 1"><i class="iconfont icon-clock"></i>{{$t('pending')}}</span>
                <span v-if="item.gmCheckStatus == 2"><i class="iconfont icon-clock"></i>{{$t('refused')}}</span>
                <span v-if="item.gmCheckStatus == 3"><i class="iconfont icon-clock"></i>{{$t('approved')}}</span>
              </div>
              <div class="remind" @click="remindApproval"  v-if="(item.gmCheckStatus == 1 || item.gmCheckStatus == 2) && isOwner">
                <span :data-value="item.gmId" :data-status="item.gmCheckStatus" ><img src="../assets/images/buzutixing.png">{{$t('remindApproval')}}</span>
              </div>
            </div>
            <div class="approver-copier row" v-for='(item, index) in this.approverList' :key="index">
              <div class="">
                <span>{{$t('approver')}}:  {{item.materialApproverName}}</span>
              </div>
              <div class="approver">
                <span v-if="item.materialApproverStatus == 0"><i class="iconfont icon-clock"></i>{{$t('sayInformed')}}</span>
                <span v-if="item.materialApproverStatus == 1"><i class="iconfont icon-clock"></i>{{$t('pending')}}</span>
                 <span v-if="item.materialApproverStatus == 2"><i class="iconfont icon-clock"></i>{{$t('refused')}}</span>
                <span v-if="item.materialApproverStatus == 3"><i class="iconfont icon-clock"></i>{{$t('approved')}}</span>
              </div>
              <div class="remind" @click="remindApproval"  v-if="(item.materialApproverStatus == 0 || item.materialApproverStatus == 1 || item.materialApproverStatus == 2) && isOwner">
                <span :data-value="item.materialApproverId" :data-status="item.materialApproverStatus"><img src="../assets/images/buzutixing.png">{{$t('remindApproval')}}</span>
              </div>
            </div>
            <div v-if="this.ccNameList !='' " class="cc-name-list">
              <div class="copier">{{$t('ccPeople')}}  {{this.ccNameList}}</div>
            </div>
            <div class="member row">
              <div class="total"><strong>{{this.inviteData.invitedCount}}</strong>{{$t('InviteNumber')}}</div>
              <div class="audited"><strong>{{this.inviteData.auditedCount}}</strong>{{$t('approved')}}</div>
              <div class="unaudited"><strong>{{this.inviteData.pendingReviewCount}}</strong>{{$t('pending')}}</div>
            </div>
            <transition name="slide-fade" v-show="this.visitReason">
              <div class="other" v-show="this.showOther">
                <div class="area" v-if="this.inviteData.visitAreaDetail">{{$t('accessSubdivisionArea')}}  {{this.inviteData.visitAreaDetail}}</div>
                <div class="purpose" v-if="this.inviteData.visitReason">{{$t('visitPurpose')}}  {{this.inviteData.visitReason}}</div>
              </div>
            </transition>
            <div class="handle-group clearfix" v-show="this.visitReason">
              <div v-on:click="showOther = !showOther" class="btn-toggle">
                <span v-if="!this.showOther"><i class="iconfont icon-down"></i>{{$t('expand')}}</span>
                <span v-else><i class="iconfont icon-up"></i>{{$t('hide')}}</span>
              </div>
            </div>
            <div class="operation row" v-if="this.isOwner && !this.isSpecialVisitor" :class="{'operationBtn': this.visitReason}">
              <div v-if="this.$route.name != 'inviteDetailGate'" class="process-go-out"  @click="handleProcessGoOut">{{$t('DealGoOut')}}</div>
              
              <div class="delete" @click="deleteInvite" v-show="!this.confirmVisite" v-if="this.inviteData.invitationStatus == 1 || this.inviteData.invitationStatus == 11 || this.inviteData.invitationStatus == 12 || this.inviteData.invitationStatus == 13 ">{{$t('delete')}}</div>
              <div class="modify" @click="modifyInvite" v-if="!this.confirmVisite && !this.isCarrierTicket">{{$t('modify')}}</div>
            </div>
            <div class="operation row" v-else-if="this.inviteData.isWarehouseManager && !this.isSpecialVisitor">
              <div v-if="this.$route.name != 'inviteDetailGate'" class="process-go-out"  @click="handleProcessGoOut()">{{$t('AddNotes')}}</div>
            </div>
          </div>
        </div>
        <div class="header-bg"></div>
      </div>
      <div class="content" ref="content" :class="{'lookImgs': this.lookImgs}">
        <div class="warehouse" v-if='(this.inviteGoodsList.length == 0 && this.isGoodsListChecker)  ||  (this.inviteGoodsList.length != 0)'>
          <div class="view-header">
            <h4 v-if="this.isWareHouse">{{$t('goodsInfo')}}</h4>
            <h4 v-if="!this.isWareHouse">{{$t('ExitPermit')}}</h4>
            <div v-on:click="togglewarehouse" class="btn-toggle">
              <span v-if="!this.showVisitorHouse">{{$t('expand')}}<i class="iconfont icon-down"></i></span>
              <span v-else>{{$t('hide')}}<i class="iconfont icon-up"></i></span>
            </div>
          </div>
          <div class="warehouse-box" v-show="this.showVisitorHouse" v-if="this.inviteGoodsList.length== 0 && this.isGoodsListChecker">
            <div class="warehouse-header">
              <div class="row">
                <div class="col-5">
                  <h5 v-if="this.isWareHouse"><i class="iconfont icon-truck"></i>{{$t('goodsInfo')}}</h5>
                  <h5 v-if="!this.isWareHouse"><i class="iconfont icon-truck"></i>{{$t('ExitPermit')}}</h5>
                </div>
                <div class="col-7">
                  <span v-if="this.isWareHouse">{{$t('noGoodsInfo')}}</span>
                  <span v-if="!this.isWareHouse">{{$t('noExitPermitInfo')}}</span>
                </div>
              </div>
            </div>
            <div class="addWarehouse comfirmWarehouseBtn" v-if="!this.confirmVisite && !isSpecialVisitor" @click="addWarehouse({isNewAdd: true})">
              <span v-if="this.isWareHouse">{{$t('confirmGoods')}}</span>
              <span v-if="!this.isWareHouse">{{$t('confirmExit')}}</span>
            </div>
          </div>
          <div class="warehouse-box" v-else v-show="showVisitorHouse" v-for="(item, index) in this.inviteGoodsList" :key="index">
            <div class="warehouse-header">
              <div class="row">
                <div class="col-5">
                  <h5 v-if="isWareHouse"><i class="iconfont icon-truck"></i>{{$t('goodsSheet')}}</h5>
                  <h5 v-if="!isWareHouse"><i class="iconfont icon-truck"></i>{{$t('ExitPermit')}}</h5>
                </div>
                <div class="col-7" v-show="item.isEditAndDelete" v-if="!confirmVisite && !isSpecialVisitor">
                  <button class="btn btn-default" :data-value="item.id" @click="deleteCheckDetail">{{$t('delete')}}</button>
                  <button class="btn btn-red" @click="addWarehouse({
                    id: item.id,
                    ticketId: item.ticketId,
                    goodsSerialNumber: item.goodsSerialNumber,
                    isDangerous: item.isDangerous,
                    goodsDetail: item.goodsDetail,
                    goodsImages: item.goodsImages,
                    checkUsers: item.checkUsers,
                    isNewAdd: false,
                    sealNumber: item.sealNumber,
                    numberPlateList: item.numberPlateList,
                    shipmentNumber: item.shipmentNumber
                  })">{{$t('modify')}}</button>
                </div>
              </div>
            </div>
            <div class="warehouse-content">
              <ul>
                <li v-if="item.numberPlateList && item.numberPlateList.length > 0">{{$t('VisitCarNumber')}}:&nbsp;&nbsp;<span v-for="(car, index) in item.numberPlateList" :key="index">{{car.displayContent}} </span></li>
                <li v-if="item.goodsSerialNumber">{{$t('goodsNo')}}&nbsp;&nbsp;{{item.goodsSerialNumber}}</li>
                <li>{{$t('dangerous')}}&nbsp;&nbsp;<span :class="{'dangerous': item.isDangerous}">{{item.isDangerous == true ? $t('yes') :  $t('no')  }}</span></li>
                <li v-if="item.shipmentNumber">{{$t('ShippingNumber')}}:&nbsp;&nbsp;{{item.shipmentNumber}}</li>
                <li v-if="item.sealNumber">{{$t('SealNumber')}}:&nbsp;&nbsp;{{item.sealNumber}}</li>
                <li>{{$t('detailedDescription')}}:&nbsp;&nbsp;{{item.goodsDetail}}</li>
                <li class="upload-img-list row" v-if="item.goodsImages!='' "><div>{{$t('uploadImage')}}: </div>
                  <div @click="lookGoodImgs">
                    <span :data-value="item.goodsImages" class="lookImgs">{{$t('viewImage')}}</span>
                  </div>
                <!--   <span v-for="(img, idx) in goodsImages[index]">{{img}}</span> -->
                </li>
                <li v-for="(check, index) in item.checkUsers" v-if="item.checkStatus != 1" :key="index">
                  <span v-if="check.checkStatus != 1">{{$t('approver')}}:&nbsp;&nbsp;{{check.userName}}(<span class="dangerous">{{check.checkStatus == '1' ? $t('pending') : check.checkStatus == '2' ? $t('refused') : $t('approved')}}</span>)
                  </span>
                </li>
                <li v-for="(check, index) in item.checkUsers" v-if="item.checkStatus==1" :key="index">
                  <span>{{$t('approver')}}:&nbsp;&nbsp;{{check.userName}}(<span class="dangerous">{{check.checkStatus == '1' ? $t('pending') : check.checkStatus == '2' ? $t('refused') : $t('approved')}}</span>)
                  </span>
                </li>
                <li>{{$t('reporter')}}:&nbsp;&nbsp;{{item.submitUserName}}</li>
                <li v-if="item.goodsCreateTime">{{$t('creatTime')}}:&nbsp;&nbsp;{{item.goodsCreateTime}}</li>
                <li v-if="item.goodsCheckTime">{{$t('approveTime')}}:&nbsp;&nbsp;{{item.goodsCheckTime}}</li>
                <li v-if="item.checkStatus == 2">{{$t('reason')}}:&nbsp;&nbsp;{{item.rejectReason}}</li>
              </ul>
            </div>
            <div class="row status-btn" v-show="item.isChecker && item.checkStatus!=3" v-if="!isSpecialVisitor">
              <div :data-value="item.id" @click="rejectCheckDetail">
                <span :data-value="item.id">{{$t('reject')}}</span>
              </div>
              <div :data-value="item.id" @click="agreeCheckDetail">
                <span :data-value="item.id">{{$t('approve')}}</span>
              </div>
            </div>
          </div>
          <div class="addWarehouse" v-if='this.inviteGoodsList.length > 0 && this.isWareHouse && !this.confirmVisite && this.isGoodsListChecker && !isSpecialVisitor' @click="addWarehouse({isNewAdd: true})" v-show="this.showVisitorHouse ">
            <i class="iconfont icon-add"></i><span>{{$t('newGoodsSheet')}}</span>
          </div>
          <div class="addWarehouse" v-if='this.inviteGoodsList.length > 0 &&  !this.isWareHouse && !this.confirmVisite && this.isGoodsListChecker && !isSpecialVisitor' @click="addWarehouse({isNewAdd: true})" v-show="this.showVisitorHouse ">
            <i class="iconfont icon-add"></i><span>{{$t('newExitPermit')}}</span>
          </div>
        </div>
        <div class="visitor-list-wrapper">
          <visitorList ref="visitorDataList"
            :inviteStatus = "1"
            :inviteId = "this.routId"
            :progressData = "this.progress"
            :isTicket = "this.isOwner"
            :isCheckOwner = "this.isCheckOwner"
            :invitationStatus="this.invitationStatus"
            :confirmVisite="this.confirmVisite"
            :confirmVisiteTxt="this.visiteTxt"
            :securityGuardPostId="this.securityGuardPostId"
            :isSpecialVisitor="this.isSpecialVisitor"
            @addNotesInfo="addNotesInfo"
            @popupStatus="changeStatus"
            @popupTip="popupTipModal"
            @popupGmModal="popupGmModal"
            @approveAllListModal="approveAllListModal"
            @approveAllModal="approveAllListModal"
            @showLookImgs="showLookImgs"
            @isLoadingShow="isLoadingShow"
            @invitatisonStatusShow="invitatisonStatusShow"></visitorList>
        </div>
      </div>
      <transition name="fade">
        <div class="reason" v-show="this.showPopup">
          <div class="reson-inner" :class="{ focused: isKeyboardUp }">
            <i class="iconfont icon-close" @click="showPopup = !showPopup"></i>
            <h4>{{$t('reason')}}</h4>
            <div class="row reson-option" v-if="this.isOwner">
              <div class="col-4">{{$t('reason')}}</div>
              <div class="col-8 refuse-reson">
                <div @click="reasonShow = !reasonShow">
                  <span>{{selectReason}}</span><i class="iconfont icon-right"></i>
                </div>
                <ul v-show="reasonShow">
                  <li @click="selectVal($t('chooseTheReason'))">{{$t('chooseTheReason')}}</li>
                  <li @click="selectVal(item.content)" :key="index" :tab='item.id'  v-for='(item, index) in this.RejectType'>
                    {{item.content}}
                  </li>
                </ul>
                <!-- <select @change="selectVal" v-model="selectReason">
                  <option>{{$t('chooseTheReason')}}</option>
                  <option  :key="index" :tab='item.id'  v-for='(item, index) in this.RejectType'>{{item.content}}</option>
                </select> -->
              </div>
            </div>
            <p>{{$t('fillDetailsHere')}}<span v-show="this.isOwner">{{$t('optional')}}</span></p>
            <div class="form-group">
              <textarea  @blur="blurRejection" @focus="focusRejection"  rows="3" :placeholder= "$t('fillDetailsHere')" v-model="textareaAll">{{textareaAll}}</textarea>
            </div>
            <div class="form-action" v-if="this.isOwner">
              <button class="btn btn-gradient" @click="commitReason">{{$t('submit')}}</button>
            </div>
            <div class="form-action" v-if="!this.isOwner && this.isCheckOwner">
              <button class="btn btn-gradient" @click="commitAllReason">{{$t('submit')}}</button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="reason" v-if="this.inviteGoodsList.length" v-show="this.showCheckPopup">
          <div class="reson-inner" :class="{ focused: isKeyboardUp }">
            <i class="iconfont icon-close" @click="closeCheckModal"></i>
            <h4>{{$t('reason')}}</h4>
            <p>{{$t('description')}}</p>
            <div class="form-group">
              <textarea @blur="blurRejection" @focus="focusRejection" rows="3" :placeholder="$t('fillDetailsHere')" v-model="textareaCheckDetail">{{textareaCheckDetail}}</textarea>
            </div>
            <div class="form-action">
              <button class="btn btn-gradient" @click="commitCheckReason">{{$t('submit')}}</button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="reason addNodes" v-show="this.showPopupNodes">
          <div class="reson-inner" :class="{ focused: isKeyboardUp }">
            <i class="iconfont icon-close" @click="showPopupNodes = !showPopupNodes"></i>
            <h4>{{$t('AddNotes')}}</h4>
            <p>{{$t('TimeoutDate')}}<span v-if="this.targetDate">{{this.targetDate}}</span></p>
            <p>{{$t('FillInNotes')}}</p>
            <div class="form-group">
              <textarea  @blur="blurRejection" @focus="focusRejection"  rows="3" :placeholder="$t('fillDetailsHere')" v-model="textareaAddNodes" />
            </div>
            <div class="form-action">
              <button class="btn btn-gradient" @click="commitNodes">{{$t('submit')}}</button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="tip" v-show="this.modalTip">
          <div class="tip-inner">
            <div class="tip-text">{{modalTipText}}</div>
            <div class="comfirmBtn" @click="modalTip = !modalTip">{{ $t('confirm') }}</div>
          </div>
        </div>
      </transition>
      <transition>
        <div v-show="this.showComfirmDelete">
          <tipModal ref="detailDialogShow"  :currentStatus="this.deleteInvitationId" :invitationId = "this.routId" @closeModal="closeModal"   :goodsListId="this.goodsListId" :approverId="this.approverId"></tipModal>
        </div>
      </transition>
    </div>
    <div>
      <transition name="fade">
        <div class="visit-show" v-show="this.newWareHouseShow">
         <div>
           <newWareHouse ref="detailDialog" :carNumberList="this.carNumberList" :invitationId="this.routId" @closeNewWarehouse="closeNewWarehouse" :currentGoods="this.currentGoods" ></newWareHouse>
         </div>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div class="visit-show" v-show="isModifyInviteShow">
        <div>
          <newInvisit @getMessage="handleGetMessage" :inviteInfo="inviteInfo"></newInvisit>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="visit-show" v-show="this.photoSwipeModal">
        <div>
          <photoSwipe ref="photoSwiper" @closePhoto="closePhoto"></photoSwipe>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="visit-show" v-show="this.processGoOut">
        <div>
          <process-go-out :invitationId = "this.routId" :isWarehouseManager="this.inviteData.isWarehouseManager" :isOwner="this.isOwner" @closeProcessGoOut="closeProcessGoOut"></process-go-out>
        </div>
      </div>
    </transition>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <alertModal
      :modalType="'simple'"
      :isModalShown="isShowAddError"
      :modalTitle="$t('noVisitorsInfo')"
      @cancel="isShowAddError = !isShowAddError">
    </alertModal>
  </div>
</template>

<script>
import visitorList from '@/components/visitorList.vue';
import newWareHouse from '@/components/newWareHouse.vue';
import tipModal from '@/components/tipModal.vue';
import newInvisit from '@/components/newInvisit.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  getTotalCarNumberINfo, getOverviewInfo, getInvitationInfo, getInvitationSchedule, getRejectReasons, materialReview, checkPassOrReject, sendRemind, goodsListCheckPassOrReject,
  getInvitationInfoForEdit, getDeliveryTrackingAdminList, SecurityGuardPostId, getInvitationInfoForAgreeToLeave, getChectoutRemarkByDate, addChectoutRemark
} from '@/utils/api';
import { checkNested } from '@/utils/utils';
import photoSwipe from '@/components/photoSwipe.vue';
import ProcessGoOut from '@/components/ProcessGoOut.vue';
import alertModal from '@/components/alertModal.vue';
const MobileDetect = require('mobile-detect');
const md = new MobileDetect(window.navigator.userAgent);
const isiPhone = md.is('iPhone');

export default {
  name: 'InviteDetail',
  components: {
    visitorList,
    newWareHouse,
    tipModal,
    newInvisit,
    Loading,
    photoSwipe,
    alertModal,
    ProcessGoOut
  },
  data() {
    return {
      showOther: true,
      scrolled: false,
      inviteData: {},
      userType: 'warehouse',
      isTicketOwner: false,
      showPopup: false,
      modalTip: false,
      modalTipText: '',
      textareaAll: '',
      approverList: [],
      ccNameList: '',
      gmListShow: false,
      gmList: [],
      visitReason: false,
      isOwner: false,
      isCheckOwner: false,
      lessonList: '',
      routId: 0,
      showCheckPopup: false,
      goodsListId: '',
      textareaCheckDetail: '',
      selectReason: this.$t('chooseTheReason'),
      checkList: [],
      visitorData: [],
      visitorListArray: [],
      progress: [],
      RejectType: [],
      DeleteText: '',
      showVisitorHouse: true,
      newWareHouseShow: false,
      showComfirmDelete: false,
      deleteInvitationId: '',
      inviteGoodsList: [],
      goodsImages: [],
      currentGoods: {},
      approverId: '',
      isGoodsListChecker: false,
      lookImgs: false,
      // modify invite
      isLoading: false,
      isModifyInviteShow: false,
      inviteInfo: null,
      photoSwipeModal: false,
      visitorMaterial: '',
      invitationStatus: -1,
      isKeyboardUp: false,
      checkUserList: [],
      visiteTxt: '',
      confirmVisite: false,
      isWareHouse: false,
      reasonShow: false,
      carNumberList: '',
      carNumberInfo: [],
      isShowAddError: false,
      
      // KO进入邀请详情页面 查看针对超过12点才离开的访客
      isSpecialVisitor: false,
      showPopupNodes: false,
      visitorTrackIdList: [],
      securityGuardPostId: "",
      isCarrierTicket: false,
      targetDate: "",
      textareaAddNodes: "",
      // 出门处理
      processGoOut: false,
      addNotesTips: "",
    };
  },
  created() {
    const routeID = this.$route.params.id; 
    this.routId = routeID;
    if (this.$route.name == "inviteDetailSpecial") {
       this.isSpecialVisitor = true;
    } else {
      this.isSpecialVisitor = false;
    }
    // top detail
    
    const securityGuardPostId = this.$route.params.gate;
    getOverviewInfo(routeID).then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        if (res.data.content.model) {
          this.inviteData = res.data.content.model;
          console.log('详情信息');
          console.log(this.inviteData);
        } else {
          this.$router.push({ path: `/` });
        }
        if (this.inviteData.approverList) {
          this.approverList = this.inviteData.approverList;
        }
        if (this.inviteData.ccName) {
          const ccNameList = this.inviteData.ccName;
          this.ccNameList = ccNameList.join('/');
        }
        if (this.inviteData.gmList) {
          this.gmList = this.inviteData.gmList;
          this.gmListShow = true;
        } else {
          this.gmListShow = false;
        }
        if (this.inviteData.visitAreaDetail === '' && this.inviteData.visitReason === '') {
          this.visitReason = false;
        } else {
          this.visitReason = true;
        }
        this.isOwner = this.inviteData.isOwner;
        this.isCheckOwner = this.inviteData.isCheck;
        if (this.inviteData.lessonName) {
          const lessonName = this.inviteData.lessonName;
          this.lessonList = lessonName.join('/');
        }
        this.trackingType = this.inviteData.trackingType;
        this.invitationStatus = this.inviteData.invitationStatus;

        if(this.inviteData.isCarrierTicket) {
          this.isCarrierTicket = this.inviteData.isCarrierTicket;
        }
      }
    });
    if (!this.isSpecialVisitor) {
      //get car number imformation
      getTotalCarNumberINfo(routeID).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.model) {
            const carNumberLists = res.data.content.model;
            console.log('在访访客');
            console.log(res.data.content.model);
            
            this.carNumberInfo = [];
            carNumberLists.forEach(item => {
              this.carNumberInfo.push(item);
            });
            this.carNumberList = JSON.stringify(this.carNumberInfo);
          }
        }
      });

      const RejectType = 1;
      getRejectReasons(RejectType).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model);
          this.RejectType = res.data.content.model;
        }
      });
      
      // confirm visite 
      this.securityGuardPostId = securityGuardPostId;
      if (this.securityGuardPostId) {
        SecurityGuardPostId(routeID, this.securityGuardPostId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            this.visiteTxt = res.data.content.model;
            this.confirmVisite = this.visiteTxt != '' ? true : false;
            // console.log(this.confirmVisite);
          }
        })
      }
    }
    
    const _this = this;
    async function runApi() {
      if (_this.isSpecialVisitor) {
        const guardPostId = _this.$route.params.guardPostId;
        const targetDate = _this.$route.params.targetDate;
        _this.targetDate = targetDate;
        console.log('is special visitor');
        return await getChectoutRemarkByDate(routeID, guardPostId, targetDate);  
      } 
      else if (securityGuardPostId == undefined) {
        console.log('is normal');
        return await getInvitationInfo(routeID);
      } 
      else {
        console.log('is security guard');
        return await getInvitationInfoForAgreeToLeave(routeID,securityGuardPostId); 
      }
    }

    runApi().then(res => {
      if (checkNested(res, 'data', 'content', 'model')) {
        if (res.data.content.model) {
          _this.visitorData = res.data.content.model.visitorList;
          console.log('详情数据');
          console.log(res.data.content.model);
          console.log('访客数据');
          console.log(_this.visitorData);
          var visitorMaterialList = [];
          const visitorMaterial = _this.visitorData.map((x,id) => {
            x.materialOptionInfoList.map(function(index, elem) {
              visitorMaterialList.push(index);
            })
          });

          _this.visitorMaterial = visitorMaterialList.length;
          if (_this.visitorData) {
            _this.$refs.visitorDataList.getData(_this.visitorData);
            _this.$refs.visitorDataList.hideVisitor(_this.visitorMaterial,_this.approverList.length,_this.gmListShow);
          }
          
          _this.isTicketOwner = res.data.content.model.isTicketOwner;
          _this.isGoodsListChecker = res.data.content.model.isGoodsListChecker;
          _this.isWareHouse = _this.trackingType == 2 || _this.trackingType == 3 ? true : false;

          if (res.data.content.model.inviteGoodsList) {
            _this.inviteGoodsList = res.data.content.model.inviteGoodsList;

            const newGoodsImages = _this.inviteGoodsList.map((item, index) => {
              const newArray = item.goodsImages;
              return newArray;
            });

            const newGoodsImgesArray = [];
            for (let i = 0; i < newGoodsImages.length; i++) {
              const newArray = [];
              for (let j = 0; j < newGoodsImages[i].length; j++) {
                const idx = newGoodsImages[i][j].lastIndexOf('\/');
                const list = newGoodsImages[i][j].substring(idx + 1, newGoodsImages[i][j].length);
                newArray.push(list);
              }
              newGoodsImgesArray.push(newArray.join('/'));
            }
            _this.goodsImages = newGoodsImgesArray;
          }
        }
      }
    });
    
    // progress
    getInvitationSchedule(routeID).then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        // console.log(res.data.content.model);
        this.progress = res.data.content.model;
      }
    });

  },
  watch:{
    '$route.name':function(newVal,oldVal){
      if(newVal === 'inviteDetailSpecial'){
        this.isSpecialVisitor = true;
      } else {
        this.isSpecialVisitor = false;
      }
    },
    '$route': function() {
      window.location.reload();
    }
  },
  updated() {
    window.scroll(0, 0);
  },
  methods: {
    focusRejection() {
      if (isiPhone) {
        setTimeout(() => {
          this.isKeyboardUp = true; // assume keyboard is up, though not perfect way
        }, 300);
      }
    },
    blurRejection() {
      this.isKeyboardUp = false;
    },
    handleScroll() {
      // console.log(this.$refs.detail);
      if (document.documentElement.clientHeight < document.body.clientHeight + 1) {
        this.scrolled = this.$refs.detail.scrollTop != 0;
      }
    },
    changeStatus(status, checkList) {
      this.showPopup = status;
      this.checkList = checkList;
      // console.log(checkList);
    },
    popupTipModal(status, txt) {
      this.modalTip = status;
      this.modalTipText = txt;
    },
    popupGmModal(status, txt) {
      this.showPopup = status;
    },
    selectVal(value) {
      this.reasonShow = false;
      const getValue = value === this.$t('chooseTheReason') ? '' : value;
      this.selectReason = value;
      if (this.textareaAll.indexOf(getValue) != -1 || getValue.indexOf(this.$t('choose')) != -1) {
        this.textareaAll = `${this.textareaAll}`;
      } else {
        this.textareaAll = `${this.textareaAll + getValue}`+ ', ';
      }
    },
    commitReason() {
      if (this.textareaAll != '' || this.selectReason != this.$t('chooseTheReason')) {
        let getReason = {};
        if (this.selectReason != this.$t('chooseTheReason')) {
          getReason = {
            invitationId: this.routId,
            idList: this.checkList,
            isPass: 0,
            reason: this.textareaAll,
          };
        } else { 
          getReason = {
            invitationId: this.routId,
            idList: this.checkList,
            isPass: 0,
            reason: this.textareaAll,
          };
        }
        // console.log(getReason);
        this.isLoading = true;
        materialReview(getReason).then((res) => {
          this.isLoading = false;
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              window.location.reload();
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('chooseTheReason');
      }
    },
    commitAllReason() {
      if (this.textareaAll != '') {
        const getReason = {
          id: this.routId,
          isPass: false,
          reason: this.textareaAll,
        };
        this.isLoading = true;
        checkPassOrReject(getReason).then((res) => {
          this.isLoading = false;
          if (res.data.content.status === 1) {
            window.location.reload();
          } else {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('pleaseFillReason');
      }
    },
    commitNodes() {
      if (this.textareaAddNodes != '') {
        var postData = [];
        this.visitorTrackIdList.forEach(item => {
          postData.push({
            visitorTrackId: item.visitorTrackId,
            remark: this.textareaAddNodes
          });
        });
        // console.log('提交的数据');
        // console.log(postData);
        this.isLoading = true;
        addChectoutRemark(postData).then((res) => {
          this.isLoading = false;
          if (res.data.content.status === 1) {
            window.location.reload();
          } else {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('PleaseFillInNotes');
      }
    },
    deleteInvite() {
      const invitationId = this.routId;
      if (invitationId) {
        this.goodsListId = '';
        this.deleteInvitationId = 'deleteInvitationId';
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'deleteInvitationId',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      }
    },
    handleProcessGoOut() {
      this.processGoOut = true;
    },
    togglewarehouse() {
      this.showVisitorHouse = !this.showVisitorHouse;
    },
    addWarehouse(checkGoodsObj) {
      getDeliveryTrackingAdminList(this.routId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.model) {
            this.checkUserList = res.data.content.model;
            var checkUserListLength = this.checkUserList.length;
            if (!checkGoodsObj.isNewAdd) {
              this.newWareHouseShow = true;
              this.$refs.detailDialog.loadDialogData(checkGoodsObj, false, checkUserListLength,this.isWareHouse);
            } else {
              console.log('是否再远');
              console.log(this.carNumberInfo);
              if(!this.carNumberInfo.length) {
                this.isShowAddError = true;
               return;
              }

              this.currentGoods = null,
              this.newWareHouseShow = true;
              this.$refs.detailDialog.loadDialogData('', false, checkUserListLength,this.isWareHouse);
            }
          }
        }
      });
      
    },
    closeNewWarehouse(status) {
      this.newWareHouseShow = status;
    },
    closeProcessGoOut(status) {
      this.processGoOut = status;
    },
    closeModal(status) {
      this.showComfirmDelete = status;
    },
    approveAllListModal(status, txt) {
      this.modalTip = status;
      this.modalTipText = txt;
    },
    remindApproval(e) {
      const ApproverId = e.target.dataset.value;
      const statusId = e.target.dataset.status;
      if (statusId == 1) {
        this.deleteInvitationId = 'remindApproval';
        this.approverId = ApproverId;
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'remindApproval',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      } else {
        sendRemind(ApproverId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      }
    },
    deleteCheckDetail(e) {
      const GoodsListId = e.target.dataset.value;
      this.invitationId = this.routId;
      this.goodsListId = GoodsListId;
      if (this.invitationId && this.goodsListId) {
        this.deleteInvitationId = 'deleteCheckGoods';
        this.showComfirmDelete = true;
        const showObj = {
          currentTxt: 'deleteCheckGoods',
        };
        this.$refs.detailDialogShow.loadDialogData(showObj);
      }
    },
    rejectCheckDetail(e) {
      if (this.inviteGoodsList.length) {
        this.showCheckPopup = true;
        this.goodsListId = e.target.dataset.value;
      }
    },
    commitCheckReason() {
      // console.log(this.goodsListId);
      const goodsListId = this.goodsListId;
      const InvitationId = this.routId;
      if (this.textareaCheckDetail != '') {
        const getGoodObj = {
          goodsListId,
          ticketId: InvitationId,
          isPass: false,
          reason: this.textareaCheckDetail,
        };
        goodsListCheckPassOrReject(getGoodObj).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            if (res.data.content.status === 1) {
              window.location.reload();
            } else {
              this.modalTip = true;
              this.modalTipText = res.data.content.message;
            }
          }
        });
      } else {
        this.modalTip = true;
        this.modalTipText = this.$t('pleaseFillReason');
      }
    },
    agreeCheckDetail(e) {
      const goodsListId = e.target.dataset.value;
      const InvitationId = this.routId;
      const getGoodObj = {
        goodsListId,
        ticketId: InvitationId,
        isPass: true,
        reason: '',
      };
      goodsListCheckPassOrReject(getGoodObj).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (res.data.content.status == 1) {
            window.location.reload();
          } else {
            this.modalTip = true;
            this.modalTipText = res.data.content.message;
          }
        }
      });
    },
    closeCheckModal() {
      this.showCheckPopup = false;
      this.textareaCheckDetail = '';
    },
    showLookImgs(status) {
      this.lookImgs = status;
    },
    modifyInvite() {
      this.isModifyInviteShow = true;
      getInvitationInfoForEdit(this.routId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.inviteInfo = res.data.content.model;
        }
      });
    },
    // TODO: this event's name is quite strange
    handleGetMessage() {
      this.isModifyInviteShow = false;
    },
    lookGoodImgs(e) {
      const imgs = e.target.dataset.value;
      const imgArr = imgs.split(',');
      if (imgArr) {
        this.photoSwipeModal = true;
        this.$refs.photoSwiper.loadPhoto(imgArr);
        this.lookImgs = true;
      }
    },
    closePhoto() {
      this.photoSwipeModal = false;
    },
    isLoadingShow(status) {
      this.isLoading = status;
    },
    invitatisonStatusShow(status,text) {
      this.modalTipText = text ;
      this.modalTip = status;
    },
    addNotesInfo(status, data) {
      this.showPopupNodes = status;
      this.visitorTrackIdList = data;
    }
  },
};
</script>
<style lang="scss" scoped>
.btn {
  &:focus,
  &:hover {
    box-shadow: none;
  }
}
.btn-default {
  border: 1px solid #929292;
  color: #9b9b9b;
}
.btn-red {
  color: #e42029;
  border: 1px solid #e42029;
}
.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  &:hover {
    color: #fff;
  }
}
.invite-detail {
  background: #fff;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  .header {
    height: auto;
    background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
    position: relative;
    z-index: 9;
    color: #fff;
    font-size: 13px;
    border-radius: 0;
    padding-bottom: 40px;
    &.posiFix {
      z-index: 11;
    }
    &.operationDele {
      padding-bottom: 10px;
    }
    .header-inner {
      padding: 15px;
      position: relative;
      z-index: 9;
      .top {
        & > div:last-child {
          text-align: right;
          padding-right: 30px;
        }
      }
      .posiFix {
        position: fixed;
        top: 0;
        z-index: 11;
        width: 100%;
        padding: 10px 0;
        background-image: linear-gradient(40deg, #f36443, #e42029), linear-gradient(8deg, #f36443, #ab272d);
        align-items: center;
      }
    }
    .title {
      font-size: 16px;
      margin-bottom: 15px;
      font-weight: bold;
    }
    &:before {
      content: '';
      width: 110px;
      height: 110px;
      border-radius: 0 0 0 110px;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      border-left: 30px solid #fff;
      border-bottom: 30px solid #fff;
      opacity: 0.12;
    }
    .status-send-msg {
      .status {
        font-size: 13px;
        i {
          margin-right: 5px;
          font-size: 13px;
        }
      }
      .send-msg {
        font-size: 12px;
        text-align: right;
        span {
          border-bottom: 1px solid #fff;
        }
      }
    }
    .approver-copier {
      margin: 0;
      display: block;
      clear: both;
      & > div {
        float: left;
      }
      & > div:first-child {
        width: 150px;
      }
      .approver {
        padding: 0;
        flex-basis: 120px;
        span {
          border: 1px solid #fff;
          margin-left: 10px;
          padding: 1px;
          font-size: 11px;
          i {
            font-size: 12px;
          }
        }
      }
      .remind {
        text-align: right;
        margin-left: 1em;
        float: right;
        span {
          cursor: pointer;
          padding-bottom: 2px;
          border-bottom: 1px solid #fff;
          font-size: 11px;
        }
      }
    }
    .cc-name-list {
      clear: both;
    }
    .member {
      clear: both;
      & > div {
        padding: 0 15px;
      }
      strong {
        font-size: 15px;
        margin-right: 5px;
      }
    }
    .operation {
      float: right;
      margin-top: 10px;
      &.operationBtn {
        margin-top: 8px;
      }
      div {
        cursor: pointer;
        border-radius: 17px;
        border: solid 1px #ffffff;
        padding: 3px 20px;
        margin-right: 10px;
      }
      .process-go-out {
        padding: 3px 14px;
      }
      & > div:last-child {
        margin-right: 25px;
      }
    }
  }
  .go-back {
    color: #fff;
    .iconfont {
      font-size: 22px;
    }
  }
  .handle-group {
    margin-top: 10px;
  }
  .btn-toggle {
    float: left;
    i {
      font-size: 12px;
      display: inline-block;
      transform: scale(0.5,0.5);
      margin-right: -2px;
    }
    span {
      display: block;
      padding: 0 5px 0 0;
      font-size: 11px;
      background: rgba(255,255,255,.35);
      line-height: 20px;
      border-radius: 10px;
    }
  }
  .btn-edit {
    font-size: 13px;
    line-height: 28px;
    padding: 0 20px;
    border-radius: 15px;
    border: 1px solid #fff;
    float: right;
    i {
      margin-right: 5px;
      display: inline-block;
    }
  }
  .header-bg {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    z-index: 1;
    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: 0.06;
    }
    &:before {
      width: 80px;
      height: 80px;
      border-radius: 0 80px 0 0;
      border-right: 30px solid #fff;
      border-top: 30px solid #fff;
    }
    &:after {
      width: 150px;
      height: 150px;
      border-radius: 0 150px 0 0;
      border-right: 30px solid #fff;
      border-top: 30px solid #fff;
    }
  }
  .content {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    //padding-top: 20px;
    width: 100%;
    margin-top: -10px;
    position: relative;
    z-index: 10;
    &.lookImgs {
      z-index: 12;
    }
  }
  .warehouse {
    & > div:nth-of-type(2) {
      margin-top: 20px;
    }
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    font-size: 13px;
    color: #4a4a4a;
    box-shadow: 0 0 15px rgba(100,100,100,.1);
   .view-header {
     position: relative;
     margin-bottom: 0px;
     h4 {
       font-size: 18px;
       font-weight: bold;
       margin-bottom: 0;
     }
     .btn-toggle {
       position: absolute;
       top: 0;
       right: 0;
       span {
         font-size: 13px;
       }
       i {
         transform: scale(.75,.75);
         margin-left: 5px;
       }
     }
   }
   .warehouse-box {
     width: 100%;
     margin: 0 auto 20px;
     border-radius: 4px;
     background: #fff;
     padding: 15px 0;
     font-size: 13px;
     color: #4a4a4a;
     box-shadow: 0 0 15px rgba(100,100,100,.1);
   }
  }
  .warehouse-header {
    padding: 0 20px 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid rgba(101, 101, 101, 0.15);
    i {
      color: #e42029;
      margin-right: 5px;
      font-weight: normal;
    }
    h5 {
      font-size: 13px;
      font-weight: bold;
    }
    .col-5 {
      padding-right: 0;
      white-space: nowrap;
    }
    .col-7 {
      text-align: right;
    }
    .btn {
      height: 26px;
      border-radius: 13px;
      padding: 0 12px;
      line-height: 25px;
      font-size: 12px;
      & + .btn {
        margin-left: 10px;
      }
    }
  }
  .warehouse-content {
    padding: 0 20px;
    ul {
      padding: 0;
      list-style: none;
    }
    li {
      line-height: 2;
      span.dangerous {
        color: #e42029;
      }
    }
    .upload-img-list {
      word-break: break-all;
      margin: 0;
    }
    .lookImgs {
      cursor: pointer;
      text-decoration: underline;
      color: #e42029;
    }
  }
  .status-btn {
    padding: 0 20px;
    margin: 0;
    margin-top: 20px;
    div {
      width: 45%;
      cursor: pointer;
    }
    & > div:first-child {
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      border: solid 1px #979797;
      text-align: center;
      span {
        font-size: 15px;
        font-weight: 600;
        color: #929292;
      }
    }
    & > div:last-child {
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      background-image: linear-gradient(71deg, #f36443, #e42029);
      text-align: center;
      margin-left: 10%;
      span {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
      }
    }

  }
  .addWarehouse {
    width: 100%;
    background-image: linear-gradient(81deg, #f36443, #e42029);
    height: 46px;
    text-align: center;
    color: #fff;
    line-height: 46px;
    border-radius: 5px;
    margin-top: 20px;
    cursor: pointer;
    &.comfirmWarehouseBtn {
      width: 60%;
      margin: 20px auto 0;
    }
    i {
      font-size: 15px;
      margin-right: 5px;
    }
    span {
      font-size: 15px;
      font-weight: 600;
      color: #fff;
    }
  }
  .visitor-list-wrapper {
    padding-top: 0px;
    margin-top: 0px;
    border-radius: 10px;
  }
}
.scrolled {
  .header:before,
  .header-bg {
    display: none;
  }
  .header {
    .title {
      margin-bottom: 0;
    }
  }
}
.operationDele {
  .header {
    padding-bottom: 10px;
  }
}
.show-popup,
.show-modal,
.show-status {
  height: 100vh;
  overflow: hidden;
  color: #4a4a4a;
  .reason,
  .tip {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.4);
    .tip-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 270px;
      border-radius: 12px;
      background-color: #fcfcfc;
      text-align: center;
      .tip-text {
        padding: 20px 8px 15px;
        font-size: 17px;
        color: #4a4a4a;
      }
      .comfirmBtn {
       padding: 12px;
       font-size: 17px;
       color: #e42029;
      }
    }
    .icon-close {
      position: absolute;
      top: 10px;
      right: 5%;
      z-index: 10;
      font-size: 22px;
    }
  }
  .reson-inner {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10;
    padding: 20px 5%;
    &.focused {
      padding-bottom: 300px;
    }
    h4 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    p {
      font-size: 13px;
      margin-bottom: 5px;
    }
    .reson-option {
      margin-bottom: 20px;
    }
    .refuse-reson {
      position: relative;
      text-align: right;
      & > div {
        span {
          color: #4a4a4a;
          font-size: 13px;
        }
      }
      input {
        width: 150px;
        margin-right: 10px;
        font-size: 13px;
        color: #4a4a4a;
        text-align: right;
        margin-right: 5px;
        cursor: pointer;
      }
      ul {
        position: absolute;
        top: 25px;
        right: 21px;
        background: #fff;
        border: 1px solid #929292;
        width: 165px;
        text-align: left;
        li {
          &:hover {
            background: #0074e8;
            color: #fff;
          }
          list-style: none;
          line-height: 24px;
          color: #4a4a4a;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    textarea {
      width: 100%;
      height: 175px;
      border: none;
      background: #f0f0f0;
      padding: 8px;
      font-size: 13px;
    }
    .form-group {
      margin-bottom: 25px;
    }
    .form-action {
      margin-bottom: 20px;
    }
    .btn {
      width: 100%;
    }
    .btn:hover {
     color: inherit;
    }
  }
  .addNodes {
    .reson-inner {
      h4 {
        font-size: 20px;
        margin-bottom: 8px;
      }
      p {
        font-size:14px;
        span {
          float: right;
        }
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.visit-show {
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top:0;
  z-index: 15;
  background:rgba(0, 0, 0, 0.4);
  .invisitListContent {
    position: absolute;
    bottom: 0;
  }
}

</style>
